import React from 'react';
import { Link } from 'react-router-dom';
import { Home, SearchX } from 'lucide-react';
import { BRAND_NAME } from '../config/brand';

/**
 * Soft-404 UI for unknown SPA routes. Paired with noindex in RouteSEO.
 * HTTP 404 status requires nginx config (see deploy/nginx-seo.conf).
 */
const NotFound: React.FC = () => {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 py-12 text-center" dir="rtl">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-50">
        <SearchX className="h-8 w-8 text-green-800" aria-hidden />
      </div>
      <p className="mb-2 text-sm font-semibold text-gold-600">خطأ 404</p>
      <h1 className="mb-3 text-2xl font-bold text-green-900 sm:text-3xl font-cairo-bold">
        الصفحة غير موجودة
      </h1>
      <p className="mb-8 max-w-md text-sm leading-relaxed text-gray-600 sm:text-base">
        عذراً، الرابط الذي طلبته غير متوفر على {BRAND_NAME}. يمكنك العودة للرئيسية أو تصفح كورسات الصفوف
        الأزهرية.
      </p>
      <div className="flex w-full max-w-sm flex-col gap-3 sm:max-w-none sm:flex-row sm:justify-center">
        <Link
          to="/"
          className="inline-flex min-h-11 items-center justify-center gap-2 rounded-xl bg-green-800 px-6 py-2.5 text-sm font-semibold text-white hover:bg-green-900"
        >
          <Home className="h-4 w-4" />
          الرئيسية
        </Link>
        <Link
          to="/courses/grade/secondary1"
          className="inline-flex min-h-11 items-center justify-center rounded-xl border border-green-800 px-6 py-2.5 text-sm font-semibold text-green-800 hover:bg-green-50"
        >
          كورسات أولى ثانوي
        </Link>
        <Link
          to="/contact"
          className="inline-flex min-h-11 items-center justify-center rounded-xl border border-gray-300 px-6 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-50"
        >
          تواصل معنا
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
